<template lang="pug">
AppTable.insights-leaderboard-table(
  ref="table"
  :key="remoteVsOffice ? 'member-overview' : 'leaderboard'"
  :hoverable="false"
  :selectable="false"
  :table-data="data"
  :loading="loading"
  :rows-count="rowsCount"
  alt-field="user.deactivated"
  @sort="sort"
)
  InsightsMemberOverviewColumns(
    v-if="remoteVsOffice"
    :data="data"
    :show-metrics="false"
    :sort-options="sortOptions"
    :loading="loading"
    @sort="sort"
  )
  InsightsLeaderboardColumns(
    v-else
    :data="data"
    :show-metrics="showMetrics"
    :sort-options="sortOptions"
    :loading="loading"
    @sort="sort"
  )
</template>

<script>
import InsightsLeaderboardColumns from './InsightsLeaderboardColumns.vue';
import InsightsMemberOverviewColumns from './InsightsMemberOverviewColumns.vue';
import { InsightsFilters, InsightsTracking } from '~/mixins';
import { mapGetters } from 'vuex';

export default {
  name: 'InsightsLeaderboardTable',
  components: {
    InsightsLeaderboardColumns,
    InsightsMemberOverviewColumns,
  },
  mixins: [InsightsFilters, InsightsTracking],
  props: {
    data: {
      type: Array,
      required: true,
    },
    showMetrics: {
      type: Boolean,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ placement: 'top' }),
    memberRemovedTooltip: 'This member has been removed from the organization',
  }),
  computed: {
    ...mapGetters(['remoteVsOffice']),
    rowsCount() {
      return this.data.length || 10;
    },
  },
  methods: {
    switchMember(user) {
      const string = `${user.id}_user_id`;

      this.setPreviousView({ previousView: this.selectedFilter, currentView: string });
      this.setSelectedFilter(string);
      this.setMembersFilter(string);
    },
    buildSortOptions(field) {
      return {
        field,
        direction: this.sortOptions.field === field ? this.sortOptions.direction : null,
      };
    },
    sort(options) {
      this.$emit('sort', options);
    },
    hasAchievements(row) {
      return row.achievements && row.achievements.length;
    },
  },
};
</script>
